import { trackByIndex } from 'src/app/shared/utils/track-by.util';
import { Component, EventEmitter, Input, OnInit, Output, ChangeDetectionStrategy } from '@angular/core';
import { ExposureBySEGs, ExposureByTaskGroup, ExposureByTaskGroupVm } from 'src/app/models/exposureBySeg.model';
import { ErrorConstants } from 'src/app/shared/constants/error.constants';

@Component({
  standalone: false,
  selector: 'app-exposure-contribution-by-task-group',
  templateUrl: './exposure-contribution-by-task-group.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./exposure-contribution-by-task-group.component.scss']
})
export class ExposureContributionByTaskGroupComponent implements OnInit {
  @Input() exposureBySEGsAll: ExposureBySEGs[];
  @Input() loading: boolean = true;

  exposureByTaskGroupVm: ExposureByTaskGroupVm[] = [];

  @Input() set exposureByTaskGroup(value: ExposureByTaskGroup[]) {
    this.exposureByTaskGroupVm = (value || []).map(task => {
      const changePercent = (task?.change ?? 0) * 100;
      return {
        ...task,
        changePercent,
        changeAbsPercent: Math.abs(changePercent).toFixed(2),
      };
    });
  }

  @Output() toggleTaskGroupPopupEmit = new EventEmitter<any>();
  @Output() sortAllSEGEmit = new EventEmitter<any>();

  showInfo: boolean = false;
  showAllPopup: boolean = false;
  errorHtml: string = "";

  constructor(
  ) {
    this.errorHtml = ErrorConstants.errorHtml;
  }

  ngOnInit(): void {
  }

  toggleTaskGroupPopupFn(task: ExposureByTaskGroup) {
    this.toggleTaskGroupPopupEmit.emit(task)
  }

  public trackByIndex = trackByIndex;
}
